import React, { useState } from 'react';

const ConfirmationPage = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleContinue = async () => {
    setLoading(true);
    setError(null);

    try {
      const purchaseData = {
        userId: '64f83abc1234567890abcdef', // replace with actual user ID
        domain: 'myfitnessproshop.com',
        isNewDomain: true,
        themeId: 'Fitness Pro',
        packageType: 'Add-on',
        features: ['POS', 'Inventory'],
        paymentStatus: 'CAPTURED'
      };

      const res = await fetch('/api/saas/payment-confirmation', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(purchaseData)
      });

      const data = await res.json();
      if (res.ok) {
        setSuccess(true);
      } else {
        throw new Error(data.error || 'Activation failed');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-8 bg-gray-100">
      <div className="bg-white shadow-lg rounded-2xl p-8 w-full max-w-xl">
        <h2 className="text-2xl font-bold mb-4 text-center text-green-700">🎉 You&#39;re Almost Ready!</h2>
        <p className="text-gray-600 text-center mb-6">
          You&#39;ve successfully selected your theme, configured your domain, and purchased the POS + Inventory package.
        </p>

        {success ? (
          <div className="text-center text-green-600 font-medium">
            ✅ Your store is now active! Check your email for login credentials.
          </div>
        ) : (
          <>
            <button
              onClick={handleContinue}
              disabled={loading}
              className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-xl w-full text-lg font-semibold transition duration-200"
            >
              {loading ? 'Activating...' : 'Continue & Activate POS + Inventory'}
            </button>

            {error && (
              <p className="mt-4 text-red-500 text-sm text-center">❌ {error}</p>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ConfirmationPage;
